var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurple02Desktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2174.55 676.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1074.97,
    y1: 690.55,
    x2: 1074.97,
    y2: 13.88,
    gradientTransform: "translate(12.04 -13.66) rotate(-.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6465f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9233e9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.01,12.11c140.18-47.4,193.48,57.97,431.06,82.68C935.67,122.1,965.01,3.2,1257.01,16.36c183.54,8.27,236.7,58.16,340.83,75.66,18.97,3.19,35.24,4.71,49.52,5.32,34.81,1.48,62.06.08,77.71-1.32,110.56-9.92,177.02-40.63,247.02-28.55,99.22,17.12,157.16,111.86,163.09,121.88,57.89,97.73,52.48,243.16-19.77,316.01-111.4,112.34-266.99-63.6-563.02,26.79-113.09,34.53-204.82,79.15-394.69,121.33-36.61,8.13-78.7,12.07-131.21,9.06-221.73-12.71-252.77-122.14-445.07-99.67-191.9,22.42-240.29,140.67-365.92,108.27C96.81,640.52,5.78,500.4.27,363.29-6.5,194.99,116.53,54.53,242.01,12.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurple02Desktop);
export default __webpack_public_path__ + "static/media/purple_02_desktop.34982f88e25f037c8fecf2f425dc9670.svg";
export { ForwardRef as ReactComponent };